import React, { Component, Fragment } from 'react';
import { Tag, Icon, Alert } from 'antd';

export class SymbolCard extends Component {
    render() {
        return (
            <Fragment>
                {this.renderSection('buy', 'Buy')}
                {this.renderSection('sell', 'Sell')}
                {this.renderSection('dca_buy', 'Buy')}

                {this.renderSection('rt_sell', 'Reverse Sell')}
                {this.renderSection('rt_buy', 'Reverse Buy')}
                {this.renderSection('rt_final_sell', 'Final Sell')}
            </Fragment>
        );
    }

    renderSection(mode, heading) {
        const { data } = this.props;

        if (!data[mode]) return null;
        if (data[mode].error) return null;
        return (
            <Fragment>
                <div>
                    <b style={{ color: '#a187ff' }}>{heading}</b>
                </div>
                {this.renderGroups(data[mode])}
            </Fragment>
        );
    }

    renderGroups(data) {
        if (data.hide_indicators)
            return (
                <Alert
                    message="The author has restricted the ability to view indicator output"
                    type="warning"
                    icon={<Icon type="lock" />}
                    showIcon
                />
            );

        if (!data.groupResponses) return null;
        return data.groupResponses.map((group, groupId) => {
            return (
                <div key={groupId} style={{ marginLeft: 15, marginBottom: 5 }}>
                    <div style={{ marginBottom: 5 }}>
                        {group.group_name}: Concensus:{' '}
                        <Tag color={group.signal.hasSignal ? '#436b45' : null}>
                            {group.signal.concensus}/{group.signal.min_concensus}
                        </Tag>
                        &nbsp;&nbsp;Required concensus:{' '}
                        <Tag>
                            {group.signal.required_concensus}/{group.signal.min_required_concensus}
                        </Tag>{' '}
                    </div>
                    <div style={{ marginLeft: 15 }}>{this.renderSignals(group.signal.signals)}</div>
                    <div style={{ textAlign: 'right' }}>{group.signal.updated_at}</div>
                </div>
            );
        });
    }

    renderSignals(signals) {
        if (!signals) return;

        return signals
            .sort((a, b) => {
                if (!a || !b) {
                    console.log(a, b);
                    return -1;
                }
                return b.fired - a.fired;
            })
            .map((signal, i) => {
                if (!signal) {
                    return (
                        <div key={i} style={{ marginBottom: 8 }}>
                            Error with signal, check signal configuration
                        </div>
                    );
                }

                return (
                    <div key={i} style={{ marginBottom: 8 }}>
                        {signal.fired ? (
                            <Icon
                                type="check-circle"
                                theme="filled"
                                style={{ color: '#436b45', marginRight: 5 }}
                            />
                        ) : (
                            <Icon
                                type="close-circle"
                                theme="filled"
                                style={{ color: '#ba7272', marginRight: 5 }}
                            />
                        )}
                        Candle: {signal.candles_back === 0 ? 'Last' : signal.candles_back}{' '}
                        {signal.a_label}: <Tag>{signal.a}</Tag> {this.getClause(signal.clause)}{' '}
                        {signal.b_label}: <Tag>{signal.b}</Tag>
                    </div>
                );
            });
    }

    getClause(clause) {
        switch (clause) {
            case 'eq':
                return 'Equals';
            case 'lt':
                return 'Less than';
            case 'lte':
                return 'Less than or equals';
            case 'gt':
                return 'Greater than';
            case 'gte':
                return 'Greater than or equals';
            case 'cross_above':
                return 'Cross above';
            case 'cross_below':
                return 'Cross below';
            default:
                return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/IndicatorsView/SymbolCard.js